import { BaseObject } from '../BaseObject';

export abstract class Base extends BaseObject
{
	
}